import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetStandingOrdersQuery } from 'lib/services';
import { PAYMENT, PAYMENT_STANDING_ORDER_PAYEE } from 'constants/shared/routes';
import StandingOrder from '../presentational/StandingOrder';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import Button from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'lib/languages/useTranslate';

const StandingOrderContainer = () => {
    const navigate = useNavigate();
    const {
        data: standingOrders,
        isLoading,
        error,
    } = useGetStandingOrdersQuery();
    const translate = useTranslate('standingOrders');

    const handleAddClick = () => {
        navigate(PAYMENT_STANDING_ORDER_PAYEE);
    };

    return (
        <>
            <SectionTitle
                title={translate('standingOrders')}
                backRoute={PAYMENT}
            />
            <DataCheck
                data={standingOrders}
                isLoading={isLoading}
                error={error}
                noDataMessage={translate('noDataMessage')}
            >
                <StandingOrder data={standingOrders ?? []} />
            </DataCheck>
            <Button className="center" onClick={handleAddClick}>
                {translate('setupStandingOrder')}
            </Button>
        </>
    );
};

export default StandingOrderContainer;
